<script setup lang="ts">
// Row of a <dl> summary list, the parent provides the <dl> and dividers
defineProps<{
  label: string
  value?: string | number | null
}>()
</script>

<template>
  <div class="flex items-center justify-between gap-4 px-4 py-3">
    <dt class="text-muted-foreground text-sm">{{ label }}</dt>
    <dd class="min-w-0 text-right break-words">
      <slot>
        <span class="font-medium">{{ value }}</span>
      </slot>
    </dd>
  </div>
</template>
